import { render, staticRenderFns } from "./show-mediation-requestes.vue?vue&type=template&id=29010665&"
import script from "./show-mediation-requestes.vue?vue&type=script&lang=js&"
export * from "./show-mediation-requestes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports